import { render } from "./ChatMessage.vue?vue&type=template&id=2801ec4f&scoped=true"
import script from "./ChatMessage.vue?vue&type=script&lang=js"
export * from "./ChatMessage.vue?vue&type=script&lang=js"

import "./ChatMessage.vue?vue&type=style&index=0&id=2801ec4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2801ec4f"]])

export default __exports__